import { Segmented, SegmentedProps } from 'antd';
import { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

// services

const MainCapitalPage: FunctionComponent = () => {
	const { t } = useTranslation();

	const [currentView, setCurrentView] = useState<'raise' | 'decrease'>('raise');

	const tabItems: SegmentedProps['options'] = [
		{
			value: 'raise',
			label: t('ACTIONS.RAISE'),
		},
		{
			value: 'decrease',
			label: t('ACTIONS.DECREASE'),
			disabled: true,
		},
	];

	return (
		<>
			<Segmented
				size="large"
				block
				options={tabItems}
				className="custom mb-2"
				value={currentView}
				onChange={(value) => {
					setCurrentView(value.valueOf() as 'raise' | 'decrease');
				}}
			/>

			<Outlet />
		</>
	);
};

export default MainCapitalPage;
